export default "__VITE_ASSET__DsMkR88M__"